let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ay3sK")).then(() => parcelRequire('fLfZY'));